import { isNil } from 'lodash';
import { playStimulusAudio } from '../stimulus/stimulusButtonActions';
import {
    blockScreen, unblockScreen, activateNextButton, deactivateNextButton,
} from '../screen/screenActions';
import { playAudio } from '../audio/audioActions';
import selectors from '../../rootSelectors';
import { startQuestionTimeTracking, resetQuestionTimeTracking } from '../timeTracking/timeTrackingActions';

export const SELECT_POSSIBLE_RESPONSE = 'SELECT_POSSIBLE_RESPONSE';
export const HIGHLIGHT_POSSIBLE_RESPONSE = 'HIGHLIGHT_POSSIBLE_RESPONSE';
export const SELECT_CLASSIFIED_RESPONSES = 'SELECT_CLASSIFIED_RESPONSES';
export const SET_QUESTIONS_STATE = 'SET_QUESTIONS_STATE';
export const MAKE_FIRST_ATTEMPT = 'MAKE_FIRST_ATTEMPT';
export const ACTIVATE_READY_FOR_NEXT_SCREEN = 'ACTIVATE_READY_FOR_NEXT_SCREEN';
export const RESET_QUESTIONS_STATE = 'RESET_QUESTIONS_STATE';
export const RESET_SELECTED_RESPONSE_INDEX = 'RESET_SELECTED_RESPONSE_INDEX';
export const RESET_SELECTED_MULTI_CHOICE_INDEXES = 'RESET_SELECTED_MULTI_CHOICE_INDEXES';
export const ADD_TO_RESPONSE_START_TIME = 'ADD_TO_RESPONSE_START_TIME';
export const START_RESPONSE_PLAYING = 'START_RESPONSE_PLAYING';
export const STOP_RESPONSE_PLAYING = 'STOP_RESPONSE_PLAYING';
export const SELECT_MULTIPLE_RESPONSES = 'SELECT_MULTIPLE_RESPONSES';
export const RESET_CLASSIFIED_RESPONSES = 'RESET_CLASSIFIED_RESPONSES';
export const SET_IS_QUESTION_COMPLETED = 'SET_IS_QUESTION_COMPLETED';

export const highlightPossibleResponse = (index) => ({
    type: HIGHLIGHT_POSSIBLE_RESPONSE,
    index,
});

export const setQuestionsState = (questionsState) => ({
    type: SET_QUESTIONS_STATE,
    questionsState,
});

export const selectPossibleResponse = (index) => ({
    type: SELECT_POSSIBLE_RESPONSE,
    index,
});

export const selectMultipleResponses = (responseIndexes) => ({
    type: SELECT_MULTIPLE_RESPONSES,
    responseIndexes,
});

export const makeFirstAttempt = () => ({
    type: MAKE_FIRST_ATTEMPT,
});

export const activateReadyForNextScreen = () => ({
    type: ACTIVATE_READY_FOR_NEXT_SCREEN,
});

export const resetQuestionsState = () => ({
    type: RESET_QUESTIONS_STATE,
});

export const resetQuestionsAndTimeTrackingState = () => (dispatch) => {
    dispatch(resetQuestionTimeTracking());
    return dispatch(resetQuestionsState());
};

export const narrateStimulus = (stimulusAudio, delay) => (dispatch, getState) => {
    dispatch(blockScreen());

    return dispatch(playStimulusAudio([stimulusAudio], delay))
        .then(() => {
            if (isNil(selectors.getCommonQuestionTimeStart(getState()))) {
                dispatch(startQuestionTimeTracking());
            }

            dispatch(unblockScreen());
        });
};

export const startResponsePlaying = (index) => ({
    type: START_RESPONSE_PLAYING,
    index,
});

export const stopResponsePlaying = () => ({
    type: STOP_RESPONSE_PLAYING,
});

export const playResponseAudio = (audioFiles, index, delay = 0) => {
    const audioArray = Array.isArray(audioFiles) ? audioFiles : [audioFiles];
    return (dispatch) => new Promise((resolve) => {
        if (audioArray && audioArray.length > 0) {
            return dispatch(playAudio(
                audioArray,
                delay,
                () => {
                    dispatch(startResponsePlaying(index));
                },
                () => {
                    dispatch(stopResponsePlaying());
                    resolve();
                },
            ));
        }
        return resolve();
    });
};

export const resetSelectedIndex = () => ({
    type: RESET_SELECTED_RESPONSE_INDEX,
});

export const resetSelectedMultiChoiceIndexes = () => ({
    type: RESET_SELECTED_MULTI_CHOICE_INDEXES,
});

export const resetClassifiedResponses = () => ({
    type: RESET_CLASSIFIED_RESPONSES,
});

export const setClassifiedResponses = (classifiedResponses) => ({
    type: SELECT_CLASSIFIED_RESPONSES,
    classifiedResponses,
});

export const setIsQuestionCompleted = (questionIndex, isQuestionCompleted) => ({
    type: SET_IS_QUESTION_COMPLETED,
    questionIndex,
    isQuestionCompleted,
});

export const isQuestionCompleted = (nextSelectedResponses, maxPossibleResponses) => nextSelectedResponses.length === maxPossibleResponses
            && nextSelectedResponses.length !== 0;

export const selectMultiChoiceResponses = (index, maxPossibleResponses, questionIndex) => (dispatch, getStore) => {
    const state = getStore();
    const selectedResponses = selectors.getMultiChoiceResponses(state);
    let nextSelectedResponses = [];
    if ((selectedResponses).includes(index)) {
        nextSelectedResponses = selectedResponses.reduce((result, item) => ((item === index) ? result : [...result, item]), []);
        dispatch(deactivateNextButton());
    } else {
        nextSelectedResponses = (selectedResponses.length < maxPossibleResponses)
            ? [...selectedResponses, index]
            : selectedResponses;
    }
    dispatch(selectMultipleResponses(nextSelectedResponses));
    const isCompleted = isQuestionCompleted(nextSelectedResponses, maxPossibleResponses);
    if (isCompleted) {
        dispatch(activateNextButton());
    }
    dispatch(setIsQuestionCompleted(questionIndex, isCompleted));
};
